import { render, staticRenderFns } from "./WorkRoles.vue?vue&type=template&id=f176d07c&"
import script from "./WorkRoles.vue?vue&type=script&lang=js&"
export * from "./WorkRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports